import React, {useState, useEffect} from 'react';
import propTypes from 'prop-types';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { TextContent } from '_ui-core-js/React/components/TextContent.jsx';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { Picture } from '_ui-core-js/React/components/Picture.jsx';
import { SocialMediaShare } from '_ui-core-js/React/components/SocialMediaShare.jsx';
import { Divider } from '_ui-core-js/React/components/Divider.jsx';
import { Modal } from '_ui-core-js/React/components/Modal.jsx';
import { AlertTextContent } from '_ui-core-js/React/components/AlertTextContent.jsx';
import { VIEWS } from './AiExperience.jsx';
import { getImageBuffer} from '../../store/actions/artwork.js';
import tick from '../../resources/images/tick.svg'
import { fireGTMTrackingEvent } from '_ui-core-js/utilities//fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function ArtworkPresentationScreen(props) {

  const { block, data, state, user } = props;
  const { ctas, socialMediaShare, saveConfirmation } = data;
  const { assetRootPath, enableSavingToCustomerProfile } = state.settings;
  const { navigateToInspirationAndGallery, navigateToPersonal } = state.navigationOptions;
  const { 
    token, 
    isUserLoggedIn, 
    userPreferences, 
    saveUserData, 
    setUserPreferences, 
    locale, 
    login, 
    setCustomerProfile, 
    setUserToken, 
    setIsUserLoggedIn, 
    setActiveView, 
    localStorageKey 
  } = user;
  const [ isSaved, setIsSaved ] = useState(false);
  const sharingUrl = `${window.location.origin}${window.location.pathname}#/inspiration/${state.artworkId}`

  function restartExperience() {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.ctaEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.clickCta,
      label: CORE_GTM_TRACKING_VALUES.label.createNewArtwork
    });

    state.setSelectedColorPaletteImages([]);
    state.setColorPaletteHexValues([]);
    state.setColorPaletteHexValuesSelectedIndexes([]);
    state.setColorPalettePayload([]);
    state.setSelectedUserChoicesImages([]);
    state.setSelectedCarColorCode(undefined);
    state.setArtworkUrl(undefined);
    state.setActiveView(VIEWS.login.name);
  };

  async function getArtworkBlob(url) {
    try {
      const buffer = await getImageBuffer(url)
      return new Blob([ buffer ], { type: 'image/jpeg' })
    } catch (err) {
      console.log(err)
    }
  }

  function getArtworkFilename () {
    return `lbx-${state.atmosphere}-${state.artworkId}`;
  }

  async function downloadArtwork(url) {
    try {
      var blob = await getArtworkBlob(url)
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.style.display = 'none';
      document.body.appendChild(a);

      a.href = blobUrl;
      a.download = getArtworkFilename();
      a.click();

      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);
    } catch (err) {
      console.log(err)
    }
  }

  function saveConfirmationOnClickCallback () {
    setIsSaved(true);
    state.setShowSaveArtworkConfirmationModal(false);
  }

  function saveToUsersCollection(masterpiece) {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.ctaEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.clickCta,
      label: CORE_GTM_TRACKING_VALUES.label.addToCollection
    });

    try {
      const myArtCollection = _.get(userPreferences, 'myArtCollection', []);
      
      myArtCollection.unshift(masterpiece);
      
      const payload = {
        ...userPreferences,
        myArtCollection
      }

      saveUserData({payload, setUserPreferences, locale, token})
    } catch (error) {
      console.log('cannot save user data');
      console.log(error)
    }
  }

  async function handleAddToCollection() {
    const id = state.artworkId;
    const atmosphere = state.atmosphere.toLowerCase();
    const masterpiece = {id, atmosphere};

    if (isUserLoggedIn) { 
      await saveToUsersCollection(masterpiece);
      state.setShowSaveArtworkConfirmationModal(true)
    } else { 
      try {
        localStorage.setItem(localStorageKey, JSON.stringify(masterpiece));
        setActiveView('expression');
        await login(setCustomerProfile, setUserToken, setIsUserLoggedIn)
        state.setShowSaveArtworkConfirmationModal(true)
      } catch (e) {
        console.error('Error storing object:', e);
      }
    }
  }

  useEffect(() => {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.workflowStep,
      label: CORE_GTM_TRACKING_VALUES.label.artworkScreen
    }, {
      workflow: {
        name: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience,
        step: CORE_GTM_TRACKING_VALUES.label.artworkScreen,
        conversion: 0,
        variant: (state.loggedIn && state.instagramCode) ? 'instagram' : 'not-connected'
      }
    });
  }, []);

  return (
    <>
      <div className={`${block}__artwork-presentation-screen ${block}__layout--horizontal container-xxxl`}>
        <div className='row'>
          <div className={`${block}__layout--block-one col-12 col-md-5 col-lg-4`}>
            <TextContent 
            heading={`${state.model}  ${state.atmosphere.toUpperCase()}`}
            body={state.selectedCarColorLabel}
            bodySize='h5'
            modifier='centered-mobile'
            underline={false}
            />
            <SocialMediaShare
            url={sharingUrl}
            getBlob={()=> getArtworkBlob(state.artworkUrl)}
            filename={getArtworkFilename()}
            label={socialMediaShare.label}
            labelSize='h6'
            labelUnderline={true}
            media={state.artworkUrl}
            buttons={socialMediaShare.buttons}
            align='left'
            cssAnimationDelay={0.75}
            gtmComponentGroup={LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience}
            gtmComponentName={CORE_GTM_TRACKING_VALUES.componentGroup.newCars}
            />
            <div className={`${block}__cta-container`}>
              <Button 
              label={ctas.download.label} 
              id={ctas.download.id}
              type='primary' 
              icon='download'
              onClickCallback={()=> downloadArtwork(state.artworkUrl)}
              cssAnimation={true} 
              cssAnimationName='vertical-top-bottom-clip'
              cssAnimationTrigger={true}
              cssAnimationDelay={1} 
              cssAnimationDuration={0.5}
              />
              { enableSavingToCustomerProfile &&
              <Button 
              label={isSaved ? ctas.viewCollection.label : ctas.addToCollection.label} 
              id={isSaved ? ctas.viewCollection.id : ctas.addToCollection.id}  
              type='secondary' 
              icon={isSaved ? undefined :'add'}
              onClickCallback={isSaved ? ()=> { navigateToInspirationAndGallery() } : handleAddToCollection}
              cssAnimation={true} 
              cssAnimationName='vertical-top-bottom-clip'
              cssAnimationTrigger={true}
              cssAnimationDelay={isSaved ? 0 : 1.5}
              cssAnimationDuration={0.5}
              /> }
              <Button 
              label={ctas.newArtwork.label} 
              id={ctas.newArtwork.id} 
              type='secondary' 
              icon='refresh'
              onClickCallback={restartExperience}
              cssAnimation={true} 
              cssAnimationName='vertical-top-bottom-clip'
              cssAnimationTrigger={true}
              cssAnimationDelay={2}
              cssAnimationDuration={0.5}
              />
              <Divider cssAnimationDelay={2.5}/>
              <Button 
              label={ctas.back.label} 
              id={ctas.back.id} 
              type='tertiary' 
              slim={true}
              onClickCallback={()=>{
                fireGTMTrackingEvent({
                  name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
                  componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
                  componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
                  action: LBX_GTM_TRACKING_VALUES.action.backToLbxExperience,
                  label: ''
                });

                navigateToPersonal()}
              } 
              cssAnimation={true} 
              cssAnimationTrigger={true}
              cssAnimationDelay={2.5}
              />
            </div>
          
          </div>
          <div className={`${block}__layout--block-two col-12 col-md-6 offset-md-1 offset-lg-2`}>
            <div className='c-media__breakout c-media__breakout--cover'>
              <CssAnimation
              enter={{ name: 'vertical-top-bottom-clip', duration: 1, delay: '0.5, hidden' }}
              triggerEnter={true}
              >
                <div className={`${block}__login-media-container`}>
                  <Picture 
                  className='c-media__image c-media__image--fit'
                  base={state.artworkUrl || '/resources/images/ai-art-example.jpg'}
                  />
                </div>
              </CssAnimation>
            </div>
          </div>
        </div>
      </div>
      <Modal
      id='lbx-ai-art-generation-item-saved'
      showCloseButton={false}
      showModalTrigger={state.showSaveArtworkConfirmationModal}
      backgroundModifier={'transparent'}
      closeModalTrigger={!state.showSaveArtworkConfirmationModal}
      >
        <AlertTextContent
        imgUrl={`${assetRootPath}/assets/images/tick.svg`}
        heading={saveConfirmation.heading}
        subheading={saveConfirmation.subheading}
        body={saveConfirmation.body.replace('{{ATMOSPHERE}}', `${state.atmosphere.toUpperCase()}`)}
        buttonLabel={saveConfirmation.cancelText}
        onClickCallback={() => {saveConfirmationOnClickCallback()}}
        />
      </Modal>
    </>
  )
};

ArtworkPresentationScreen.propTypes = {
  block: propTypes.string.isRequired,
  state: propTypes.object.isRequired,
  data: propTypes.object.isRequired
};
